/* ============================================================
   PALAMANO — Ficha de producto: los vídeos no se detienen

   El tema reproduce el vídeo solo cuando su diapositiva está a la
   vista y lo pausa al salir. Aquí se quiere que estén siempre en
   marcha, tanto el grande como los de las miniaturas.
   ============================================================ */
(() => {
  const dentroDeLaFicha = () => document.body.classList.contains('pmn-page-product');

  const arrancar = (video) => {
    video.muted = true; // sin esto el navegador no deja reproducir solo
    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.play().catch(() => {
      /* Algunos navegadores lo bloquean hasta que la persona toca la
         página; en cuanto lo haga, el repaso de abajo lo reintenta. */
    });
  };

  const repasar = () => {
    if (!dentroDeLaFicha()) return;

    document.querySelectorAll('product-gallery video').forEach((video) => {
      if (!video.dataset.pmnAuto) {
        video.dataset.pmnAuto = '1';
        /* El tema lo pausa al cambiar de foto: se vuelve a arrancar. */
        video.addEventListener('pause', () => {
          if (document.contains(video)) arrancar(video);
        });
      }

      if (video.paused) arrancar(video);
    });
  };

  /* ==========================================================
     El título y la valoración, en una sola fila: la valoración va
     arriba a la derecha, a la altura del título.

     Se hace moviendo los dos bloques a un contenedor común en vez de
     con `order` y columnas de CSS: la valoración va antes que el
     título en el documento, así que el grid la colocaba siempre
     primero y tiraba el título a la fila siguiente.
     ========================================================== */
  const emparejarTituloYRating = () => {
    if (!dentroDeLaFicha()) return;

    const lista = document.querySelector('.product-info__block-list');
    if (!lista) return;
    if (lista.querySelector(':scope > .pmn-fila-titulo')) return; // ya está hecho

    /* Hijos directos, para no confundirse con las estrellas de los
       productos recomendados de más abajo. */
    const titulo = lista.querySelector(':scope > :has(> .product-title)');
    const rating = lista.querySelector(':scope > :has(> .rating-badge)');
    if (!titulo || !rating) return;

    const fila = document.createElement('div');
    fila.className = 'product-info__block-item pmn-fila-titulo';
    titulo.before(fila);
    fila.append(titulo, rating);
  };

  const todo = () => {
    repasar();
    emparejarTituloYRating();
  };

  todo();

  /* La ficha se vuelve a dibujar al cambiar de variante. */
  new MutationObserver(todo).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('variant:change', todo);
  document.addEventListener('click', repasar, { once: true });
  window.addEventListener('load', todo);
})();


/* ============================================================
   PALAMANO — «Ver tabla nutricional»
   Lleva el carrusel de fotos a la del reverso del empaque, que es
   donde está la tabla. El botón lo pone snippets/palamano-tabs-producto.
   ============================================================ */
document.addEventListener('click', (evento) => {
  const boton = evento.target.closest('[data-pmn-ver-media]');
  if (!boton) return;

  const galeria = document.querySelector('product-gallery');
  const foto = galeria?.querySelector(`.product-gallery__media[data-media-id="${boton.dataset.pmnVerMedia}"]`);
  if (!foto) return;

  /* Se pulsa la miniatura que le corresponde en vez de mover el carrusel a
     mano, para que el tema se entere del cambio y marque la activa. */
  const fotos = [...galeria.querySelectorAll('.product-gallery__media')];
  const marcas = [...galeria.querySelectorAll('.scroll-marker')];
  const marca = marcas[fotos.indexOf(foto)];

  if (marca) {
    marca.click();
  } else {
    foto.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  /* En celular la galería va arriba del todo: sin esto el botón no parece
     hacer nada. */
  if (window.matchMedia('(max-width: 999px)').matches) {
    galeria.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
});


/* ============================================================
   PALAMANO — Fotos de fondo liso: enteras, sin recorte (26-oct)

   Mira las cuatro esquinas de cada foto de la galería (en una copia
   de 40 px). Si son del mismo color, es una foto de producto sobre
   fondo liso: se marca con .pmn-foto-lisa y ese color, y el CSS la
   muestra entera (`contain`) rellenando lo que sobra con su fondo.
   Las fotos de ambiente no se tocan y siguen llenando el espacio.
   ============================================================ */
(() => {
  const TOLERANCIA = 14; // diferencia máxima por canal entre esquinas

  const revisar = (media) => {
    const img = media.querySelector('img');
    if (!img || media.dataset.pmnFondo) return;
    media.dataset.pmnFondo = '1';

    const u = new URL(img.currentSrc || img.src || img.dataset.src || '', location.href);
    if (!u.pathname) return;
    u.searchParams.set('width', '40');

    fetch(u.href)
      .then((r) => r.blob())
      .then((b) => createImageBitmap(b))
      .then((bm) => {
        const c = document.createElement('canvas');
        c.width = bm.width;
        c.height = bm.height;
        const x = c.getContext('2d');
        x.drawImage(bm, 0, 0);
        const w = bm.width - 2;
        const h = bm.height - 2;
        const esquinas = [[1, 1], [w, 1], [1, h], [w, h]].map(([px, py]) =>
          Array.from(x.getImageData(px, py, 1, 1).data.slice(0, 3))
        );
        const lisa = [0, 1, 2].every((k) => {
          const v = esquinas.map((e) => e[k]);
          return Math.max(...v) - Math.min(...v) <= TOLERANCIA;
        });
        if (!lisa) return;
        const [r, g, b] = esquinas[0];
        media.style.setProperty('--pmn-foto-lisa-fondo', `rgb(${r}, ${g}, ${b})`);
        media.classList.add('pmn-foto-lisa');
      })
      .catch(() => {});
  };

  const repasar = () =>
    document
      .querySelectorAll('product-gallery .product-gallery__media[data-media-type="image"]')
      .forEach(revisar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repasar);
  } else {
    repasar();
  }
  /* El tema vuelve a dibujar la galería al cambiar de variante. */
  new MutationObserver(repasar).observe(document.documentElement, { childList: true, subtree: true });
})();
